import React from "react";
// eslint-disable-next-line no-restricted-imports
import ReactDOM from "react-dom/client";

import { FabricShell } from "@granular/fabric-core";

import App from "./App";

/**
 * NOTE: We disable ESLint's (valid) complaint because this is what the React
 * Docs tell us to do. Breathe 🌸
 *
 * https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-client-rendering-apis
 */
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <FabricShell>
      <App />
    </FabricShell>
  </React.StrictMode>
);
